<template>
  <v-card flat>
    <v-card-text class="py-0">
      <GChart
        type="ComboChart"
        :options="chartOptions"
        :data="updated_chart_data"
        :debounce="500"
        :events="chartEvents"
        @ready="onChartReady"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ComboChartVT",
  props: {
    chartData: Array,
    ylabel: String,
    xlabel: String,
    lineWidth: String,
    pointSize: String,
    dataOpacity: String,
    colors: Array,
    seriesType: String,
    series: Object,
    isStacked: Boolean,
    displayAnnotations: Boolean,
  },
  data: function () {
    return {
      chartsLib: {},
      chartOptions: {
        backgroundColor: "transparent",
        width: "100%",
        csv_headers: "1",
        height: 300,
        chartArea: { top: 30, width: "94%" },
        seriesType: this.seriesType || "lines",
        series: this.series || { 0: { type: "bars" } },
        legend: {
          position: "bottom",
          textStyle: { color: this.$vuetify.theme.dark ? "#A9A9A9" : "#a1c7e2", fontSize: "0.75em" },
          count: 3,
        },
        lineWidth: this.lineWidth || 1,
        pointSize: this.pointSize || 5,
        curveType: "function",
        isStacked: this.isStacked || false,
        dataOpacity: this.dataOpacity || 0.3,
        tooltip: { isHtml: true },
        colors: this.colors || ["#0581c6", "#e14615", "#52a0d1"],
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 50,
          easing: "in",
          startup: true,
        },
        displayAnnotations: this.displayAnnotations || false,
        vAxis: {
          title: this.ylabel,
          gridlines: { color: "#325597", count: 3 },
          minorGridlines: { color: "#fff" },
          textStyle: {
            color: this.$vuetify.theme.dark ? "#ffffff" : "#a1c7e2",
            fontSize: 9,
          }, // viewWindowMode: "maximized",
        },
        hAxis: {
          title: this.xlabel,
          textStyle: { color: this.$vuetify.theme.dark ? "#A9A9A9" : "#a1c7e2", fontSize: 9 },
          // viewWindowMode: "maximized",
        },
      },
      chartEvents: {
        select: () => {
          let selection = this.chart.getSelection()[0];
          if (selection) {
            this.$emit("on-click", this.updated_chart_data[selection.row + 1][0]);
          } else {
            this.$emit("on-click", null);
          }
        },
        error: (errorObj) => {
          if (errorObj.message == "Data column(s) for axis #0 cannot be of type string")
            window.$(`#${errorObj.id} span`)[0].innerHTML =
              "Oops, there is no data available for the selected time period.";
        },
      },
    };
  },
  methods: {
    onChartReady(chart) {
      this.chart = chart;
    },
    createCustomHTMLContent(title, msg, value) {
      return `<div class='d-flex rounded custom-tooltip'>
      <div class='pl-1 rounded-l primaryOutline'></div>
      <div class='d-flex flex-column primaryDark--text px-2'>
        <div>
          ${title}
        </div>
        <div class='primaryGrey--text caption'>
          <span class='primaryDark--text font-weight-bold'>
          ${value}
        </span>${msg}
        </div>
      </div>
    </div> `;
    },
  },
  created() {
    this.page_config = this.$config;
  },
  computed: {
    msg() {
      return this.$auth.error;
    },
    updated_chart_data() {
      return this.chartData ? this.chartData : null;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .custom-tooltip {
  width: 150px;
  min-height: 50px;
  max-height: 200px;
  border: none;
  box-shadow:
    -3px -1px 20px 0 rgba(0, 0, 0, 0.18),
    0 6px 20px 0 rgba(153, 155, 168, 0.1);
}
::v-deep .google-visualization-tooltip {
  border: none !important;
}
</style>
